export default __webpack_public_path__ + "static/media/not-found.688349fa.jpeg";